import React, { Component } from "react";
import { Button, Accordion } from "react-bootstrap";
import "./index.css";

class HomeWorkCard extends Component {
  render() {
    return (
      <div className="border shadow-sm rounded mb-2 p-3">
        <div className="d-flex align-items-center">
          <div className="th-bg-primary th-circle d-flex align-items-center">
            <div className="th-white  mx-auto">{this.props.circle}</div>
          </div>
          <div className="pl-2">
            <div className="th-12 th-medium th-cap">{this.props.subject}</div>
            <div className="th-12 th-grey th-cap">{this.props.teacher}</div>
          </div>
        </div>
        <div className="mt-2">
          <Accordion defaultActiveKey={null}>
            <div>
              <Accordion.Toggle
                as={Button}
                variant="link"
                eventKey="1"
                style={{
                  padding: 0,
                  textDecoration: "none",
                  boxShadow: "none",
                  width: "100%",
                }}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <div className="th-12 th-black text-left">
                      {this.props.AssHeading}
                    </div>
                    <div className="th-12 th-grey text-left">
                      Submission Date: {this.props.submissionDate}
                    </div>
                  </div>
                  <i class="fa fa-angle-down th-primary" aria-hidden="true"></i>
                </div>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="1">
                <div className="mt-2">
                  <div className="d-flex justify-content-between">
                    <div className="th-12 th-black text-left">
                      Date: {this.props.uploadDate}
                    </div>
                    {this.props.marks ? (
                      <div className="th-12 th-black text-left">
                        Marks: {this.props.marks}
                      </div>
                    ) : null}
                  </div>
                  <div className="th-12 th-grey text-left text-capitalize">
                    {this.props.description}
                  </div>

                  {this.props.file ? (
                    <a
                      className="btn th-btn-primary-outline mt-2 px-4 py-1"
                      href={this.props.file}
                      download
                    >
                      DOWNLOAD
                    </a>
                  ) : null}
                </div>
              </Accordion.Collapse>
            </div>
          </Accordion>
        </div>
      </div>
    );
  }
}
export default HomeWorkCard;
